export const ANIME_LIST_REQUEST = "ANIME_LIST_REQUEST";
export const ANIME_LIST_SUCCESS = "ANIME_LIST_SUCCESS";
export const ANIME_LIST_FAIL = "ANIME_LIST_FAIL";

export const ANIME_DETAIL_REQUEST = "ANIME_DETAIL_REQUEST";
export const ANIME_DETAIL_SUCCESS = "ANIME_DETAIL_SUCCESS";
export const ANIME_DETAIL_FAIL = "ANIME_DETAIL_FAIL";

export const GENRE_LIST_REQUEST = "GENRE_LIST_REQUEST";
export const GENRE_LIST_SUCCESS = "GENRE_LIST_SUCCESS";
export const GENRE_LIST_FAIL = "GENRE_LIST_FAIL";
